import { US_REGION } from "./Region";

// Represents a DB table or combination of DB tables valid only
// in US regional service (reason - not all analytics run in EU)
const _ResourceRegionalUsOnly = {
  ActiveUserCount: "active_user_counts",
} as const;

export const ResourceRegionalUsOnly = _ResourceRegionalUsOnly;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ResourceRegionalUsOnly =
  (typeof _ResourceRegionalUsOnly)[keyof typeof _ResourceRegionalUsOnly];

const RESOURCE_REGIONAL_US_ONLY_VALUES = new Set<string>(
  Object.values(ResourceRegionalUsOnly),
);

export function isResourceRegionalUsOnly(
  value: string,
): value is ResourceRegionalUsOnly {
  return RESOURCE_REGIONAL_US_ONLY_VALUES.has(value);
}

export function getRegionalUsOnlyResourceName(
  resource: ResourceRegionalUsOnly,
): string {
  return `${US_REGION}/${resource}`;
}
